import { SearchModeEnum } from "common/enums/SearchModeEnum";
import { useCallback, useEffect, useState } from "react";
import { ModeSelectDialogProps } from "./interfaces";

export const useModeSelectDialogHooks = (props: ModeSelectDialogProps) => {
  const [mode, setMode] = useState<ModeSelectDialogProps["mode"]>(props.mode);
  const [busy, setBusy] = useState(false);

  const onModeClick = useCallback(() => {
    setMode((prev) =>
      prev === SearchModeEnum.all
        ? SearchModeEnum.domain
        : prev === SearchModeEnum.domain
        ? SearchModeEnum.all
        : prev
    );
  }, []);

  const onOkClick = useCallback(() => {
    // OKボタンクリック時
    setBusy(true);
  }, []);

  useEffect(() => {
    setTimeout(() => setMode(props.mode), 0);
  }, [props.mode]);

  useEffect(() => {
    if (busy) {
      props.onOkClick(mode);
      setTimeout(() => setBusy(false), 0);
    }
  }, [busy, mode, props]);

  return { mode, busy, onModeClick, onOkClick } as const;
};
